export default __webpack_public_path__ + "static/media/E.d41f21d2.png";